"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReduxProvider = exports.useSelector = exports.useDispatch = exports.useStore = exports.reducers = exports.DELTA_MIDDLEWARE = exports.reduxContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _comments = _interopRequireDefault(require("./comments"));

var _delta = _interopRequireWildcard(require("./delta"));

var _context = _interopRequireDefault(require("./context"));

var _annotation = _interopRequireDefault(require("./annotation"));

var _constants = require("../constants");

var _reducersMap;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducersMap = (_reducersMap = {}, _defineProperty(_reducersMap, "".concat(_constants.PREFIX, ":comments"), _comments.default), _defineProperty(_reducersMap, "".concat(_constants.PREFIX, ":context"), _context.default), _defineProperty(_reducersMap, "".concat(_constants.PREFIX, ":annotation"), _annotation.default), _defineProperty(_reducersMap, "".concat(_constants.PREFIX, ":delta"), _delta.default), _reducersMap);
var composeEnhancers = process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

var reduxContext = /*#__PURE__*/_react.default.createContext(null);

exports.reduxContext = reduxContext;
var DELTA_MIDDLEWARE = _delta.deltaMiddleware;
exports.DELTA_MIDDLEWARE = DELTA_MIDDLEWARE;
var reducers = (0, _redux.combineReducers)(reducersMap);
exports.reducers = reducers;
var useStore = (0, _reactRedux.createStoreHook)(reduxContext);
exports.useStore = useStore;
var useDispatch = (0, _reactRedux.createDispatchHook)(reduxContext);
exports.useDispatch = useDispatch;
var useSelector = (0, _reactRedux.createSelectorHook)(reduxContext);
exports.useSelector = useSelector;
var store = (0, _redux.createStore)(reducers, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default, _delta.deltaMiddleware)));

var ReduxProvider = function ReduxProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    context: reduxContext,
    store: store
  }, children);
};

exports.ReduxProvider = ReduxProvider;
var _default = store;
exports.default = _default;